import {createContext} from 'react';

export interface PageMetaData {
	title?: string;
	description?: string;
	descriptionOg?: string;
	keywords?: string;
	canonicalUrl?: string;
	expires?: Date;
}

export type ScriptTagData =
	| {
			src: string;
			async?: boolean;
			defer?: boolean;
			// ... list of attributes can be extended as needed
	  }
	| {
			content: string;
			id: string;
	  };

export interface HeadTaggerContextValue {
	setPageMeta(pageMeta: PageMetaData): void;
	addScript(script: ScriptTagData): void;
	removeScript(script: ScriptTagData): void;
}

export const HeadTagSetterContext = createContext<HeadTaggerContextValue | null>(null);
